import { TASKS_PERIOD_FILTER_EVENTS } from './global-events';

export const tasksPeriodFilterOptions = [
  {
    id: 'all',
    name: 'Всі завдання',
    event: TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_ALL,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'today',
    name: 'Завдання на сьогодні',
    event: TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_TODAY,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'tomorrow',
    name: 'Завдання на завтра',
    event: TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_TOMORROW,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'week',
    name: 'Завдання на тиждень',
    event: TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_WEEK,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'month',
    name: 'Завдання на місяць',
    event: TASKS_PERIOD_FILTER_EVENTS.TASKS_PERIOD_FILTER_MONTH,
    options: {
      type: 'checkbox',
    },
  },
];
